export default __webpack_public_path__ + "static/media/group.430e06d7.svg";